module.exports = __webpack_public_path__ + "static/img/39850.b43fbf3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/39850.jpg
// module id = zYeb
// module chunks = 1